exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuCreateFrp{height:100%;position:fixed;background:#fff;z-index:251;top:0;right:0;overflow:hidden;border-radius:0 0 0 0!important}@media screen and (max-width:768px){.menuCreateFrp{width:100%}}@media screen and (min-width:1280px){.menuCreateFrp{width:30%}}.menuCreateFrp .panel-body{display:flex;flex-direction:column;height:100%;padding:0}.menuCreateFrp .panel-scroll{flex:1 1 auto;min-height:0;overflow-y:auto;padding:1.25rem 1.5rem}.menuCreateFrp .actions-footer{flex:0 0 auto;padding:12px 1.5rem;border-top:1px solid #ededed}.menuCreateFrp .field{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5046dba8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frpm/components/menuCreateFrp.vue
// module id = 2065
// module chunks = 2